export default __webpack_public_path__ + "static/media/26t.6b9954fe.jpg";